var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFeet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.833 0H1.167A1.17 1.17 0 000 1.167v11.666A1.17 1.17 0 001.167 14h11.666A1.17 1.17 0 0014 12.833V1.167A1.17 1.17 0 0012.833 0zm-.754 7.412l-2.062 2.063-.825-.825 1.066-1.067H3.742L4.809 8.65l-.826.825-2.062-2.063a.583.583 0 010-.824l2.062-2.063.825.825-1.066 1.067h6.517L9.19 5.35l.826-.825 2.062 2.063a.583.583 0 010 .824z",
    fill: "#A4A4A4"
  })));
}

export default SvgFeet;